import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const WebsiteModuleAsyncComponent = AsyncComponent(async () => import('./website.module' /* webpackChunkName: "website" */ ));

export const WebsiteModuleAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <WebsiteModuleAsyncComponent {...props}/>
  </React.Suspense>
}
